import { render, staticRenderFns } from "./ImportJson.vue?vue&type=template&id=7e64c3f1&scoped=true&"
import script from "./ImportJson.vue?vue&type=script&lang=js&"
export * from "./ImportJson.vue?vue&type=script&lang=js&"
import style0 from "./ImportJson.vue?vue&type=style&index=0&id=7e64c3f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e64c3f1",
  null
  
)

export default component.exports